import { useState } from 'react';
import ConfirmDialog from '@/components/ui/ConfirmDialog';
import { revokeApiKey } from './api-keys.service';
import type { ApiKey } from './types';

export interface RevokeKeyConfirmProps {
  item: ApiKey | null;
  onClose: () => void;
  onRevoked: () => void;
}

export default function RevokeKeyConfirm({
  item,
  onClose,
  onRevoked,
}: RevokeKeyConfirmProps) {
  const [isRevoking, setIsRevoking] = useState(false);

  const handleConfirm = async () => {
    if (!item) return;
    setIsRevoking(true);
    try {
      await revokeApiKey(item.id);
      onRevoked();
    } finally {
      setIsRevoking(false);
    }
  };

  return (
    <ConfirmDialog
      isOpen={item !== null}
      onClose={onClose}
      onConfirm={handleConfirm}
      title={`Revogar "${item?.name ?? ''}"?`}
      message={
        <span>
          A chave com prefixo{' '}
          <code style={{ fontFamily: 'monospace', background: '#f3f4f6', padding: '1px 5px', borderRadius: '3px' }}>
            {item?.prefix ?? ''}…
          </code>{' '}
          será <strong>imediatamente invalidada</strong>. Todas as integrações que a utilizam
          deixarão de funcionar. Esta ação não pode ser desfeita.
        </span>
      }
      confirmText="Revogar agora"
      cancelText="Cancelar"
      type="danger"
      isConfirming={isRevoking}
      confirmingText="Revogando..."
    />
  );
}
